module.exports = __webpack_public_path__ + "assets/img/warrior-name-4314e3e1.png";